import styled from '@emotion/styled';
import { Theme as EmotionTheme } from '@emotion/react';

interface CustomTheme {
  constants: {
    layout: {
      general: {
        top: {
          desktop: string;
          tablet: string;
          mobile: string;
        };
        sidePadding: {
          desktop: string;
          tablet: string;
          mobile: string;
        };
      };
    };
  };
  spacings: string[];
  media: {
    tablet: string;
    mobile: string;
  };
}

declare module '@emotion/react' {
  export interface Theme extends EmotionTheme, CustomTheme {}
}

export const Wrapper = styled.article`
  width: 100%;
  min-height: 100vh;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Content = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: flex-start;
  flex-direction: column;

  ${({ theme }) => theme.breakpoints.down(breakpoints.tablet)} {
    padding: 0 24px;
  }
`;
